module.exports = __webpack_public_path__ + "static/irwin-gill-hero-small-bbeebb3449ac0d078c4834838bd5c844.jpg";